import { request } from "@/utils/request";
// 查询京东商品
export function selectGoods(data) {
  return request({
    url: `/admin/jd/goods/selectGoods`,
    method: "POST",
    data,
  });
}
// 查询京东商品详情
export function selectDetails(data) {
  return request({
    url: `/admin/jd/goods/selectDetails`,
    method: "POST",
    data,
  });
}
// 克隆京东商品到自己商品数据库
export function updateGoods(data) {
  return request({
    url: `/admin/jd/goods/updateGoods`,
    method: "POST",
    data,
  });
}
// 根据京东分类查询自选商品分类
export function selectCategory(data) {
  return request({
    url: `/admin/jd/goods/selectCategory`,
    method: "POST",
    data,
  });
}


// 修改京东商品
export function updateJdGoodsApi(data) {
  return request({
    url: `/admin/jd/goods/updateJdGoods`,
    method: "POST",
    data,
  });
}